import { render, staticRenderFns } from "./ConfigStandard.vue?vue&type=template&id=646ba0c0&scoped=true&"
import script from "./ConfigStandard.vue?vue&type=script&lang=js&"
export * from "./ConfigStandard.vue?vue&type=script&lang=js&"
import style0 from "./ConfigStandard.vue?vue&type=style&index=0&id=646ba0c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "646ba0c0",
  null
  
)

export default component.exports